<template>
  <main class="dedicated-search">
    <div class="search-masthead easy over-easy">
      <div class="container">
        <div class="row">
          <div class="col-12 col-xs-12">
            <search-bar
              :placeholder="placeholder"
              :query="query"
              :remove-button-css-classes="removeButtonCssClasses"
              @change="onSearchBarChange"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-md-4">
          <hideable-filter-listing
            @change="onFilterChange"
          />
        </div>
        <div class="col-md-8">
          <p v-if="zeroResultsFound" class="zero-results-found">
            No Results found
          </p>
          <ul
            v-else
            id="search-pagination"
            class="dedicated-search-results"
          >
            <search-result
              v-for="searchResult in searchResults"
              :key="searchResult.id"
              :search-result="searchResult"
              css-prefix="dedicated"
              image-size="110px"
              :has-cursor="false"
            >
              <small
                v-if="searchResult.pageText"
                class="dedicated-search-description"
              >
                {{ truncate(searchResult.pageText, 150) }}
              </small>
            </search-result>
          </ul>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
  import AlgoliaClient from 'lib/storefront/algolia-client';
  import parseRawSearchResult from 'lib/storefront/parse-raw-search-result';
  import SearchResult from './storefront/search-form/search-result';
  import HideableFilterListing from './dedicated-search/hideable-filter-listing';
  import SearchBar from './dedicated-search/search-bar';

  export default {
    components: {
      SearchBar,
      HideableFilterListing,
      SearchResult
    },
    props: {
      placeholder: {
        type: String,
        required: false,
        default: "What are you searching for?"
      },
      initialQuery: {
        type: String,
        required: false,
        default: ''
      },
      adminLinkTemplate: {
        type: String,
        required: false,
        default: null
      },
      removeButtonCssClasses: {
        type: String,
        required: true
      }
    },
    data() {
      const searchClient = new AlgoliaClient({
        algoliaAppId: csConf.algoliaApplicationID,
        algoliaApiKey: csConf.algoliaSearchKey,
        searchIndexNames: [
          {
            displayName: 'Default Index',
            algoliaName: csConf.siteWideSearchIndexName,
            isDefault: true
          }
        ],
        searchOptions: {
          hitsPerPage: 20,
          highlightPreTag: '<strong>',
          highlightPostTag: '</strong>'
        }
      });
      return {
        searchClient,
        facetFilters: '',
        searchResults: [],
        query: this.initialQuery,
        zeroResultsFound: false
      };
    },
    created() {
      this.search();
    },
    methods: {
      onFilterChange(filterValue) {
        this.facetFilters = filterValue;
        this.search();
      },
      truncate(string, limit) {
        if (string.length <= limit) {
          return string;
        }
        return `${string.slice(0, limit)}...`
      },
      onSearchBarChange(payload) {
        this.query = payload;
        this.search();
      },
      search() {
        const vm = this;
        vm.searchClient.search({
          query: vm.query,
          facetFilters: this.facetFilters,
        }).then((searchContent) => {
          vm.zeroResultsFound = searchContent.hits.length === 0;
          vm.searchResults = searchContent.hits.map((rawHit) => {
            return parseRawSearchResult({
              rawHit,
              adminLinkTemplate: this.adminLinkTemplate,
              includePageText: true
            });
          });
        }).catch((error) => {
          console.log(error);
        });
      }
    }
  };
</script>
